module.exports = __webpack_public_path__ + "static/media/upload.b04535e1.svg";